import { Store } from '@ngrx/store';
import { CoreStoreService } from './core-store.service';
import { State as CoreState } from './core.reducer';
import {AsyncActionQueries, AsyncActionSelectors} from '@emm/core/util/async-action-state';

export class AsyncActionStoreService<T extends AsyncActionSelectors> extends CoreStoreService {

    constructor(store: Store<CoreState>, private asyncActionSelectors: T) {
        super(store);
    }

    asyncActionQueries: AsyncActionQueries = {
        error$: this.select(this.asyncActionSelectors.getError),
        isLoading$: this.select(this.asyncActionSelectors.getIsLoading),
        hasError$: this.select(this.asyncActionSelectors.getHasError),
        needsLoading$: this.select(this.asyncActionSelectors.getNeedsLoading),
        success$: this.select(this.asyncActionSelectors.getSuccess)
    };

}
